import { Mapper } from "./Mapper"

export class Mapper000 extends Mapper {
    override cpuMapRead(address: number): [mappedAddress?: number, data?: number] {
        if (address >= 0x8000 && address <= 0xffff) {
            return [address & (this.programBanks > 1 ? 0x7fff : 0x3fff)]
        }

        return []
    }

    override cpuMapWrite(address: number, _data: number): number | undefined {
        if (address >= 0x8000 && address <= 0xffff) {
            return address & (this.programBanks > 1 ? 0x7fff : 0x3fff)
        }
    }

    override ppuMapRead(address: number): number | undefined {
        if (address >= 0x0000 && address <= 0x1fff) {
            return address
        }
    }

    override ppuMapWrite(address: number): number | undefined {
        if (address >= 0x0000 && address <= 0x1fff) {
            if (!this.characterBanks) return address
        }
    }

    override reset(): number | void {}
}
